import React from 'react'

import { CvAndQualification } from './components/CvAndQualification'
import { DoctorIntroduction } from './components/DoctorIntroduction'

interface AboutMePageProps {
    className?: string
}

export const AboutMe: React.FC<AboutMePageProps> = ({ className }) => {
    return (
        <div className={`${className} flex flex-col w-full justify-center items-center`}>
            <DoctorIntroduction className="max-w-container-s" />
            <CvAndQualification classname="max-w-container-s" />
        </div>
    )
}
